export default __webpack_public_path__ + "static/media/financial tracking.4d3c5ae2.png";